import * as React from 'react';

const SvgIconSortArrowSwap = ({
  color = '#40180B',
  ...props
}: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      transform="rotate(90 12 12)"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.35355 3.35355L7.70711 3L7 2.29289L6.64645 2.64645L2.64645 6.64645L2.29289 7L2.64645 7.35355L6.64645 11.3536L7 11.7071L7.70711 11L7.35355 10.6464L4.20711 7.5H17H17.5V6.5H17H4.20711L7.35355 3.35355ZM16.6464 13.3536L16.2929 13L17 12.2929L17.3536 12.6464L21.3536 16.6464L21.7071 17L21.3536 17.3536L17.3536 21.3536L17 21.7071L16.2929 21L16.6464 20.6464L19.7929 17.5H7H6.5V16.5H7H19.7929L16.6464 13.3536Z"
      fill={color}
    />
  </svg>
);

export default SvgIconSortArrowSwap;
